export const API_GETWAY = 'https://5dfnn560ai.execute-api.eu-central-1.amazonaws.com';

const hostname = window.location.hostname;
let API_BASE_URL;

if (hostname === 'localhost') {
  API_BASE_URL = 'http://localhost:3001';
} else if (hostname.startsWith('192.168.')) {
  API_BASE_URL = `http://${hostname}:3001`; // dynamically match any 192.168.x.x
} else {
  API_BASE_URL = API_GETWAY;
}
// alert(API_BASE_URL);
// API_BASE_URL = API_GETWAY;

export { API_BASE_URL };

export const CLOUDFRONT_DOMAIN = 'https://agamim360.com';
